module.exports = __webpack_public_path__ + "static/img/组 9(1).ac8de7a2.png";